import { akEditorSelectedBorder, akEditorSelectedBorderColor, akEditorSelectedBoxShadow, akEditorSmallZIndex } from '../consts';
import { SelectionStyle } from './types';

/**
 * Adds correct selection styling for a node
 * Pass in which selection style properties you want and it will return css string of necessary styles
 *
 * eg.
 *  .expand.ak-editor-selected-node {
 *    ${getSelectionStyles([SelectionStyle.BoxShadow, SelectionStyle.Blanket])}
 *  }
 *
 */
export var getSelectionStyles = function getSelectionStyles(selectionStyles) {
  return selectionStyles.map(function (selectionStyle) {
    return getSelectionStyle(selectionStyle);
  }).concat(hideNativeBrowserTextSelectionStyles).join('\n');
};
export var hideNativeBrowserTextSelectionStyles = "\n  ::selection,*::selection {\n    background-color: transparent;\n  }\n  ::-moz-selection,*::-moz-selection {\n    background-color: transparent;\n  }\n";
var getSelectionStyle = function getSelectionStyle(style) {
  switch (style) {
    case SelectionStyle.Border:
      return "\n        border: ".concat(akEditorSelectedBorder, ";\n\n        // Fixes ED-15246: Trello card is visible through a border of a table border\n        &::after {\n          height: 100%;\n          content: '\\00a0';\n          background: ").concat(akEditorSelectedBorderColor, ";\n          position: absolute;\n          right: -1px;\n          top: 0;\n          bottom: 0;\n          width: 1px;\n          border: none;\n          display: inline-block;\n        }\n      ");
    case SelectionStyle.BoxShadow:
      return "\n        box-shadow: ".concat(akEditorSelectedBoxShadow, ";\n        border-color: transparent;\n        ");
    case SelectionStyle.Background:
      return "background-color: ".concat("var(--ds-background-selected, #E9F2FE)", ";");
    case SelectionStyle.Blanket:
      return "\n        position: relative;\n\n        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel\n        // in Safari. Looks like it's caused by user-select: all in the emoji element\n        -webkit-user-select: text;\n\n        ::before {\n          position: absolute;\n          content: '';\n          left: 0;\n          right: 0;\n          top: 0;\n          bottom: 0;\n          width: 100%;\n          pointer-events: none;\n          z-index: ".concat(akEditorSmallZIndex, ";\n          background-color: ", "var(--ds-blanket-selected, #388BFF14)", "\n        }");
    default:
      return '';
  }
};